import { render, staticRenderFns } from "./archivio.vue?vue&type=template&id=a14ebd06&"
import script from "./archivio.vue?vue&type=script&lang=js&"
export * from "./archivio.vue?vue&type=script&lang=js&"
import style0 from "./archivio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports